import { BodyText, PrimaryButton } from '@kallidus/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLoggedInUser } from '../AppConfig';
import useMasqueradeState from './useMasqueradeState';
import { ShowIcon } from '@Generic/icons';
import useCheckForLegacyMasquerade from '@ApplicationWide/checkForLegacyMasquerade';
import './MasqueradeBanner.less';

export default function MasqueradeBanner() {
  useCheckForLegacyMasquerade();
  const { user } = useLoggedInUser();
  const { isMasquerading, stopMasquerade, busy } = useMasqueradeState();
  const { t } = useTranslation();

  const viewAs = (
    <Trans i18nKey='admin.view-as' values={{ user: user?.displayName }} components={{ bold: <strong /> }} />
  );
  const permissionGroup = (
    <Trans
      i18nKey='admin.permission-status'
      values={{ user: user?.userRole?.name }}
      components={{ bold: <strong /> }}
    />
  );

  if (isMasquerading) {
    return (
      <div className='masquerade-banner'>
        <div className='banner-content'>
          <span className='banner-icon-span'>
            <ShowIcon className='banner-icon' />
            <BodyText noTopSpacer className='banner-view'>
              {viewAs}
            </BodyText>
          </span>
          <BodyText noTopSpacer className='banner-permission'>
            {permissionGroup}
          </BodyText>
        </div>
        <PrimaryButton loading={busy} onClick={stopMasquerade}>
          {t('admin.banner-btn')}
        </PrimaryButton>
      </div>
    );
  }
  return false;
}
